import {
  TrackingCustomerData,
  TrackingPageContext,
  TrackingPageTypeWithId,
  TrackingPageTypeWithoutId,
} from '../../../types';
import {TrackingClientStateHolder} from '../helpers/clientState';
import {contentView} from '../helpers/contentView';
import {SourceHistoryEventData} from '../helpers/sourceHistory';

export interface ContentViewEvent {
  GA3: ContentViewEventGA3;
  GA4: ContentViewEventGA4;
}
export interface ContentViewEventGA3 {
  event: 'contentView';
  shopVersion: string;
  shopId: string;
  timestamp: number;
  contentName: string;
  search: string;
  pageType: TrackingPageTypeWithId | TrackingPageTypeWithoutId;
  pageTypeId: number | null;
  breadcrumbs: string[];
  loadingTimeInSeconds: number;
  source: SourceHistoryEventData['source'];
  // origin click is string | null as if its null we dont push this field to data layer
  originClick: string | null;
}

export interface ContentViewEventGA4 {
  event: 'content_view';
  content_name: string;
  // document.title
  title: string | null;
  page_type: TrackingPageTypeWithId | TrackingPageTypeWithoutId;
  page_type_id: number | null;
  // origin click is string | null as if its null we dont push this field to data layer
  click_origin: string | null;
}

export const trackContentView =
  ({
    page,
    breadcrumbsPath,
    customer,
  }: {
    page: TrackingPageContext;
    breadcrumbsPath?: string | null;
    customer?: TrackingCustomerData;
  }) =>
  (clientState: TrackingClientStateHolder) => {
    const {eventGA4, eventGA3} = contentView({
      page,
      breadcrumbsPath,
      customer,
    })(clientState);

    clientState.update({originClick: ''});

    const event = {
      GA3: eventGA3 as ContentViewEventGA3,
      GA4: eventGA4 as ContentViewEventGA4,
    };

    return event;
  };
